export default "__VITE_ASSET__ClLn6x3I__"